import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

/**
 * Kiln status requires a serial in the URL. Without it, the page can half-initialize
 * and leave the previous route (e.g. landing) visibly stacked underneath.
 */
@Injectable({
  providedIn: 'root',
})
export class KilnStatusGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const tree = this.router.parseUrl(state.url);
    const kilnId = tree.queryParams['kiln_id'];
    if (kilnId != null && String(kilnId).trim() !== '') {
      return true;
    }
    return this.router.parseUrl('/landing');
  }
}
